import React from "react";
import "./Footer.scss";
import InstagramIcon from "../../assets/icon/instagram.png"; 
import footerContent from "./FooterContent"; 

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <h2 className="footer-brand">{footerContent.brandName}</h2>
        <address className="footer-address">
          {footerContent.address.map((line, index) => (
            <span key={index}>{line} <br /></span>
          ))}
        </address>
        <p className="footer-copyright">{footerContent.copyright}</p>
        <a href={footerContent.socialLinks.instagram} className="footer-icon" aria-label="Instagram">
          <img src={InstagramIcon} alt="Instagram" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
